module.exports = __webpack_public_path__ + "media/images/patent/z_8-7c3fa81a35417d37969aa0806240b0fa.png";